export default __webpack_public_path__ + "static/media/Yu-Ying.66355676.jpg";